module.exports = __webpack_public_path__ + "img/Causes-Impact to ESS.21db8966.svg";